<script setup lang="ts">
import { ref } from 'vue';
import ImageRemote from '../../mixit-ui/components/media/ImageRemote.vue';
import Tag from '../../mixit-ui/components/misc/Tag.vue';
import ButtonQuantity from '../../mixit-ui/components/button/ButtonQuantity.vue';
import type { SearchProduct } from '@/services-new/searchService';

const props = defineProps<{
  product: SearchProduct
}>();

const isFavourite = ref(false);

function mainImage(product: SearchProduct) {
  return (product.images.find(i => i.main_image) ?? product.images[0]) ?? null
}
</script>

<template>
  <div class="flex flex-col gap-4 w-full bg-white rounded-sm p-4">
    <div class="relative flex flex-row gap-4 w-full sm:items-center">
      <RouterLink
        :to="{ name: 'productPath', params: { permalink: product.permalink } }"
        class="absolute inset-0 z-2"
      />
      <div class="flex flex-row items-start flex-1 gap-4">
        <div class="lg:w-25 w-27.5">
          <ImageRemote
            v-if="mainImage(product)"
            :data="mainImage(product)!.data"
            :alt="mainImage(product)!.alt ?? product.name"
            img-class="w-full h-auto object-contain"
            loading="lazy"
          />
        </div>
        <div class="flex flex-col gap-2 items-start flex-1">
          <div class="flex flex-col gap-1">
            <span class="font-roboto-slab text-xs lg:text-sm text-brown-600 font-bold">{{ product.name }}</span>
            <!-- weight not in EP -->
            <span
              v-if="false"
              class="font-roboto-slab text-2xs lg:text-xs text-brown-300 font-bold"
            >650 g</span>
          </div>
          <!-- discount tag not in EP -->
          <span
            v-if="false"
            class="flex flex-col gap-1"
          >
            <Tag
              label="-30 % s kódem WTF26"
              severity="danger"
              size="md"
              behaviour="responsive"
            />
          </span>
        </div>
      </div>
      <div class="flex flex-col gap-6 justify-between">
        <div class="flex flex-row gap-2 lg:gap-6 items-center justify-end">
          <span class="hidden lg:flex flex-row gap-1 items-center">
            <span class="font-roboto-slab text-brown-600 text-xs font-bold">
              {{ product.price }}&nbsp;{{ product.currency }}
            </span>
          </span>
          <div class="hidden lg:flex z-3 relative">
            <ButtonQuantity
              :product-id="product.id"
              init-label="toCart"
            />
          </div>
          <!-- total/subtotal price not in EP -->
          <span
            v-if="false"
            class="hidden lg:flex font-roboto-slab text-brown-600 text-xs lg:text-sm font-bold"
          >458&nbsp;Kč</span>
          <button
            v-if="false"
            type="button"
            class="relative z-3 cursor-pointer hover:text-red-500 active:scale-90 transition"
            :class="isFavourite ? 'text-red-500' : 'text-yellow-300'"
            @click.prevent="isFavourite = !isFavourite"
          >
            <i class="mi-heart-fill text-2xl transition" />
          </button>
        </div>
      </div>
    </div>
    <div class="flex lg:hidden flex-row gap-2 items-center justify-end">
      <span class="flex flex-row gap-1 items-center">
        <span class="font-roboto-slab text-brown-600 text-xs font-bold">
          {{ product.price }}&nbsp;{{ product.currency }}
        </span>
      </span>
      <div class="z-3 relative">
        <ButtonQuantity
          :product-id="product.id"
          init-label="toCart"
          size="xs"
        />
      </div>
      <!-- total/subtotal price not in EP -->
      <span
        v-if="false"
        class="font-roboto-slab text-brown-600 text-xs lg:text-sm font-bold"
      >458&nbsp;Kč</span>
    </div>
  </div>
</template>
